import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import Layout from '../components/layout/Layout';

const AUTH_PATHS = ['/login', '/register', '/forgot-password'];

const PublicRoute = ({ children }) => {
    const { isAuthenticated } = useAuth();
    if (AUTH_PATHS.includes(window.location.pathname) && isAuthenticated)
        return <Navigate to="/" replace />;
    return <Layout>{children}</Layout>;
};

export default PublicRoute;
